import "./Billing.scss"
import React from "react"
import { observer } from "mobx-react"
import { Switch, Route } from "react-router-dom"
import { billingStore } from "../../app/stores"
import { Button, UserConfirmation } from "../../lib"
import BillingStatus from "./BillingStatus"
import StripeCardForm from "./StripeCardForm"
import CancelPlan from "./CancelPlan"
import UpdateCard from "./UpdateCard"
import Plans from "./Plans"
import { FREE_PLAN } from "./subscription-plans"
import { getPlanDescription } from "./utils"

const BillingDetails = observer(({ match }) => {
  const {
    error,
    saving,
    confirm,
    updating,
    subscribed,
    cancelConfirm,
    selectingPlan,
    createSubscription,
  } = billingStore
  return (
    <div>
      <BillingStatus />
      <Plans />
      {subscribed && (
        <p>
          Do you want to{" "}
          <Button styleType="text" to={`${match.url}/update`}>
            update your card
          </Button>
          ?
        </p>
      )}
      {subscribed && !updating && <CancelPlan />}
      {!subscribed &&
      selectingPlan &&
      selectingPlan.id !== FREE_PLAN.id && (
        <div>
          <h3>Purchase {getPlanDescription(selectingPlan)}</h3>
          <StripeCardForm
            includeEmail
            savingLabel="Upgrading..."
            promptLabel={`Upgrade to ${selectingPlan.name}`}
            saving={saving}
            error={error}
            onSubmit={form => {
              return createSubscription(
                {
                  number: form.number.value,
                  exp_month: form.exp_month.value,
                  exp_year: form.exp_year.value,
                  cvc: form.cvc.value,
                },
                form.email.value
              )
            }}
          />
        </div>
      )}
      {confirm && (
        <UserConfirmation
          loading={saving}
          message={confirm.message}
          onConfirm={confirm.onConfirm}
          onCancel={cancelConfirm}
        />
      )}
    </div>
  )
})

const Billing = ({ match }) => {
  return (
    <div className="Billing">
      <Switch>
        <Route path={`${match.path}/update`} component={UpdateCard} />
        <Route component={BillingDetails} />
      </Switch>
    </div>
  )
}

Billing.displayName = "Billing"

export default observer(Billing)



// WEBPACK FOOTER //
// ./src/account/billing/Billing.js